"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "card-row m-t-30" };
var _hoisted_2 = { class: "num" };
var _hoisted_3 = {
    class: "statistic-card",
    style: { "background": "rgba(19, 206, 102, 0.1)" }
};
var _hoisted_4 = { class: "num" };
var _hoisted_5 = {
    class: "statistic-card",
    style: { "background": "rgba(230, 162, 60, 0.1)" }
};
var _hoisted_6 = { class: "num" };
var _hoisted_7 = { class: "num" };
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
var doctor_1 = require("@/api/doctor");
var hooks_1 = require("@hview/hview-vue3/packages/hooks");
exports.default = (0, vue_1.defineComponent)({
    __name: 'home',
    setup: function (__props) {
        console.log((0, vue_router_1.useRouter)());
        var router = (0, vue_router_1.useRouter)();
        var loading = (0, hooks_1.useApp)().loading;
        var uiModel = (0, vue_3.ref)(null);
        var load = function () {
            loading.value = true;
            (0, doctor_1.getDashboardApi)().then(function (res) {
                uiModel.value = res.data;
            }).finally(function () {
                loading.value = false;
            });
        };
        var toPage = function (path) {
            router.push(path);
        };
        (0, vue_3.onMounted)(function () {
            load();
        });
        return function (_ctx, _cache) {
            var _component_h_container = (0, vue_2.resolveComponent)("h-container");
            var _directive_loading = (0, vue_2.resolveDirective)("loading");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_h_container, null, {
                default: (0, vue_2.withCtx)(function () { return [
                    (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        (uiModel.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                (0, vue_2.createElementVNode)("div", {
                                    class: "statistic-card cursor-pointer",
                                    style: { "background": "rgba(78,136,243, 0.1)" },
                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (toPage('/doctor/patient')); })
                                }, [
                                    _cache[2] || (_cache[2] = (0, vue_2.createElementVNode)("div", { class: "title" }, "中心总数", -1)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(uiModel.value.team_num), 1),
                                    _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("div", {
                                        class: "icon",
                                        style: { "color": "rgba(78,136,243, 0.8)", "background": "rgba(78,136,243, 0.2)" }
                                    }, [
                                        (0, vue_2.createElementVNode)("i", { class: "iconfont icon-shequ" })
                                    ], -1))
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                    _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("div", { class: "title" }, "成员总数", -1)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(uiModel.value.team_member_num), 1),
                                    _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("div", {
                                        class: "icon",
                                        style: { "color": "rgba(19, 206, 102, 0.8)", "background": "rgba(19, 206, 102, 0.2)" }
                                    }, [
                                        (0, vue_2.createElementVNode)("i", { class: "iconfont icon-chengyuan" })
                                    ], -1))
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                    _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("div", { class: "title" }, "7日新增", -1)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(uiModel.value.new_add_in_7_day), 1),
                                    _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("div", {
                                        class: "icon",
                                        style: { "color": "rgba(230, 162, 60, 0.8)", "background": "rgba(230, 162, 60, 0.2)" }
                                    }, [
                                        (0, vue_2.createElementVNode)("i", { class: "iconfont icon-rili" })
                                    ], -1))
                                ]),
                                (0, vue_2.createElementVNode)("div", {
                                    class: "statistic-card cursor-pointer",
                                    style: { "background": "rgba(253, 78, 78, 0.1)" },
                                    onClick: _cache[1] || (_cache[1] = function ($event) { return (toPage('/doctor/chat')); })
                                }, [
                                    _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("div", { class: "title" }, "未读消息", -1)),
                                    (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(uiModel.value.unread_num), 1),
                                    _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("div", {
                                        class: "icon",
                                        style: { "color": "rgba(253, 78, 78, 0.8)", "background": "rgba(253, 78, 78, 0.2)" }
                                    }, [
                                        (0, vue_2.createElementVNode)("i", { class: "iconfont icon-weiduxiaoxi-copy" })
                                    ], -1))
                                ])
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])), [
                        [_directive_loading, (0, vue_2.unref)(loading)]
                    ])
                ]; }),
                _: 1
            }));
        };
    }
});
